import { render, staticRenderFns } from "./MlbTvForm.vue?vue&type=template&id=303ab30a&scoped=true"
import script from "./MlbTvForm.vue?vue&type=script&lang=js"
export * from "./MlbTvForm.vue?vue&type=script&lang=js"
import style0 from "./MlbTvForm.vue?vue&type=style&index=0&id=303ab30a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303ab30a",
  null
  
)

export default component.exports